import React from 'react'
import "./BybWhyBrew.css"
import auditline from "../../../assets/selfaudit/images/auditline.png";
function BybWhyBrew() {
  return (
    <>
    <section className='whybrew'>
<div className='container'>
    <div className='whybrew-content'>
    <div className='whybrew-header'>
<h1>Why Should You Brew With Us?</h1>
<p>We are dedicated to equipping you with the tools and insights to shape your brand’s future. With the Brand Self-Audit Kit, you’ll uncover actionable strategies to refine and enhance your brand's presence. After completing the process, you’ll gain:</p>
    </div>

    <div className="whybrew-para-top">
<div className="whypara-one">
<img src={auditline} alt="Comprehensive brand understanding visual" />
<p><span style={{ color: "white" }}> Comprehensive Brand Understanding:</span> A clear and nuanced view of your brand’s strengths, areas for improvement, and growth opportunities.</p>
</div>
<div className="whypara-two">
<img className="engagement-img" src={auditline} alt="Market-ready visual identity visual" />
<p><span style={{ color: "white" }}>Market-Ready Visual Identity:</span> The foundation to direct a cohesive and impactful visual presence across all platforms.</p> 
</div>
<div className="whypara-three">
<img className="map-img" src={auditline} alt="Stakeholder insights visual" />
<p><span style={{ color: "white" }}>Valuable Stakeholder Insights:</span> A framework for gathering and interpreting feedback that supports well-informed, data-driven decisions.</p>
</div>
            </div>
            <div className="whybrew-para-bottom">
<div className="whypara-four">
<img src={auditline} alt="Enhanced customer relationships visual" />
<p><span style={{ color: "white" }}>Enhanced Customer Relationships: </span> Insights to optimise customer journeys and engagement strategies, fostering deeper loyalty and trust.</p>
</div>
<div className="whypara-five">
<img className="engagement-img" src={auditline} alt="Strategic marketing edge visual" />
<p><span style={{ color: "white" }}>Strategic Marketing Edge:</span> Practical, proven techniques to sharpen your competitive advantage and remain relevant in a dynamic market.</p> 
</div>
<div className="whypara-six">
<img className="engagement-img" src={auditline} alt="Strategic feedback framework visual" />
<p><span style={{ color: "white" }}>Strategic Marketing Edge</span> A framework for gathering and interpreting feedback that supports well-informed, data-driven decisions.</p> 
</div>

            </div>
    </div>
  

</div>
    </section>
    
    
    </>
  )
}

export default BybWhyBrew
